export default {
	gridUseYnList_: ({ gridUseYnList }) => gridUseYnList,
	resultList_: ({ resultList }) => resultList,
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	}
};
